import { render, staticRenderFns } from "./ChatbotProposals.vue?vue&type=template&id=05174a3f&scoped=true"
import script from "./ChatbotProposals.vue?vue&type=script&lang=js"
export * from "./ChatbotProposals.vue?vue&type=script&lang=js"
import style0 from "./ChatbotProposals.vue?vue&type=style&index=0&id=05174a3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05174a3f",
  null
  
)

export default component.exports